import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { textAnalysisTemplate } from 'containers/TextAnalysis/Template'

const { source, userType, orderBy, orderDirection, toolName } =
  textAnalysisTemplate

const axiosRequest = (extraParams: any = {}) => {
  return AxiosInitializer({
    token: getToken(),
    transformResConfig: false,
    paramsSerializerConfig: true,
    ...extraParams,
    tool: toolName,
  })
}

const defaultParams = {
  source,
  user_type: userType,
  sort: { [orderBy]: orderDirection },
}

function createQueryString(params: { [key: string]: [] }) {
  return Object.keys(params)
    .map((key) => {
      const values = params[key]
      return values
        .map(
          (value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
        )
        .join('&')
    })
    .join('&')
}

const taURL = {
  getList: (queryParams: any) => {
    const parentIDs = queryParams.attributes['parent.id']

    if (parentIDs && Object.keys(parentIDs).length) {
      delete queryParams.attributes['parent.id']

      return axiosRequest().get(
        `contributions?${createQueryString({
          'attributes[parent.id]': parentIDs,
        })}`,
        {
          params: { ...defaultParams, ...queryParams },
        },
      )
    } else {
      return axiosRequest().get('contributions', {
        params: { ...defaultParams, ...queryParams },
      })
    }
  },
}

const taListAPI = {
  getList: (params = {}) =>
    apiWrapper({
      endPoint: taURL.getList,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default taListAPI
